export default class CaClinicProfile {
  constructor(
    public readonly clinicId: string,
    public readonly clinicName: string,
  ) {}
}
